// MEDIA QUERY CONSTANTS

// LOCAL VALUES
const MEDIA_SCREEN = '@media only screen and';
const MIN = 'min-width:';
const MAX = 'max-width:';

// BREAKPOINTS
const MOBILE = 350;
const TABLET = 640;
const DESKTOP = 1024;
const DESKTOP_LG = 1280;
const DESKTOP_XL = 1440;

export const MIN_QUERY = `(${MIN} 0px)`;
export const MOBILE_MIN_QUERY = `(${MIN} ${MOBILE}px)`;
export const TABLET_MIN_QUERY = `(${MIN} ${TABLET}px)`;
export const DESKTOP_MIN_QUERY = `(${MIN} ${DESKTOP}px)`;
export const DESKTOP_LG_MIN_QUERY = `(${MIN} ${DESKTOP_LG}px)`;
export const DESKTOP_XL_MIN_QUERY = `(${MIN} ${DESKTOP_XL}px)`;

export const MOBILE_MAX_QUERY = `(${MAX} ${MOBILE}px)`;
export const TABLET_MAX_QUERY = `(${MAX} ${TABLET}px)`;
export const DESKTOP_MAX_QUERY = `(${MAX} ${DESKTOP}px)`;
export const DESKTOP_LG_MAX_QUERY = `(${MAX} ${DESKTOP_LG}px)`;
export const DESKTOP_XL_MAX_QUERY = `(${MAX} ${DESKTOP_XL}px)`;

export const mediaQueries = {
  mobile: `${MEDIA_SCREEN} ${MOBILE_MIN_QUERY}`,
  tablet: `${MEDIA_SCREEN} ${TABLET_MIN_QUERY}`,
  desktop: `${MEDIA_SCREEN} ${DESKTOP_MIN_QUERY}`,
  desktopLG: `${MEDIA_SCREEN} ${DESKTOP_LG_MIN_QUERY}`,
  desktopXL: `${MEDIA_SCREEN} ${DESKTOP_XL_MIN_QUERY}`,
};



// WEBPACK FOOTER //
// ./src/constants/mediaqueries.const.js